
import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialog} from '@angular/material/dialog';

export interface DialogData {
  showClose:boolean,
  message:string,
  marginLeft:string,
  fatherID:string
}
@Component({
  selector: 'mask-dailog',
  templateUrl: './mask-dailog.component.html',
})
export class MaskDialog implements OnInit {
  constructor(
    public dialog: MatDialog,
  @Inject(MAT_DIALOG_DATA) public data: DialogData,
  public dialogRef: MatDialogRef<MaskDialog>,   ) {}
  ngOnInit(): void {}
  close(){     
      this.dialogRef.close()
      if(this.data.fatherID){
        this.dialog.getDialogById(this.data.fatherID).close()
      }
  }
}